<template>
  <div id="layout" style="background: rgba(189,223,215,.8)">
    <nav class="top-nav hidden-print-only">
      <v-toolbar dense color="primary">
        <img
          src="../../assets/hil-logo.png"
          alt="HiL"
          style="height: 40px; cursor: pointer"
          class=" mr-1"
          title=""
        />
        <h2 class="ml-3 white--text app-title">
          {{ title || "Home In Love" }}
        </h2>
        <v-spacer></v-spacer>
      </v-toolbar>
    </nav>
    <slot />
  </div>
</template>

<script>
export default {
  name: "empty-with-navbar-layout",
  computed: {
    title() {
      return this.$route.meta.title;
    },
  }
};
</script>
